import { render, staticRenderFns } from "./NewCustomerForm.vue?vue&type=template&id=2c25f9ab&"
import script from "./NewCustomerForm.vue?vue&type=script&lang=js&"
export * from "./NewCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomerForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports